import { Component, HostListener, ElementRef, ViewChild, ChangeDetectorRef, OnInit } from '@angular/core';
import { VERSION as aldAppVERSION } from '../../version/version';

import * as UsersAction from '../../../../../../src/app/services/user/user.action';

import { User } from '../../../../../../src/app/models/user/user';
import { UserState } from '../../../../../../src/app/services/user/user.state';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';

import { AldFormBaseComponent } from '../../../../../../src/app/shared/components/form/ald-form.component';
import { BannerService } from '../../../../../../src/app/shared/services/banner.service';
import { HelperService } from '../../../../../../src/app/services/helper/helper.service';

import { Store, Select } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { Router } from '@angular/router';

import { AldState } from "../../../../../../src/app/services/ald/ald.state";
import * as AldActions from "../../../../../../src/app/services/ald/ald.action";


@Component({
  selector: 'app-home-panel',
  templateUrl: './home-panel.component.html',
  styleUrls: ['./home-panel.component.scss']
})

export class HomePanelComponent extends AldFormBaseComponent {

  @Select (state => state.state.userPanelState)
  upanelstate$: Observable<any>; // -> StatePanelModel {sidebarShown: any; topbarShown: any; side: string; userstate: string };

  @Select(UserState.User)
  User$: Observable<User>;


  @Select(AldState.SendMessage)
  SendMessage$: Observable<Models.ResponseBase>;

  public requestSendMessage: Models.Request<string> = new Models.Request<string>();

  constructor(
    private el: ElementRef,
    public store: Store,
    public authenticationService: AuthenticationService,
    public helperService: HelperService,
    public environmentService: EnvironmentService,
    public banner: BannerService,
    public router: Router,
    public changeDetectorRef: ChangeDetectorRef
  ) {

    super(helperService, environmentService, changeDetectorRef, router, authenticationService, store);

  }

  ngOnInit() {

    super.ngOnInit();

    this.subscription.add(this.SendMessage$.subscribe((data) => {
      if (data && data.Success && data.RequestSignature == this.requestSendMessage.RequestSignature) {
        this.requestSendMessage.End();
        this.requestSendMessage.Item = null;
        this.banner.success("Twoja wiadomość została pomyślnie wysłana.");
      }
    }));
  }


  logout() {
    this.authenticationService.logout();
  }

  public onUserAuthenitcate() { };

  public onSummary() { }

  public onSendMessage() {
    this.requestSendMessage.Begin();

    this.store.dispatch(new AldActions.SendMessage(this.requestSendMessage));
  }

  public IsMessageSendValid() {
    return (this.requestSendMessage != null && !this.requestSendMessage.IsProcessing && this.requestSendMessage.Item && this.requestSendMessage.Item.length > 10);
  }
}


